import { HttpClient } from '@shared/services/ApiClient';

export interface ProductLocation {
  id: number;
  team_id: number;
  code: string;
  type_id: number;
  type: {
    id: number;
    name: string;
  };
  is_locked: boolean;
  product_id: number;
  product: {
    id: number;
    name: string;
    image: string;
    code: string;
  };
  deleted_at: string | null;
  stock: number;
  stock_location_carts: any[];
  created_at: string;
  aisle_id: number | null;
}

export interface ProductLocationsApiResponse {
  data: ProductLocation[];
  meta: {
    total: number;
    perPage: number;
    currentPage: number;
    lastPage: number;
  };
  links: {
    first: string;
    prev: string | null;
    next: string | null;
    last: string;
  };
}

export class ProductLocationsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getProductLocations(productIds: number[]): Promise<ProductLocation[]> {
    try {
      const productIdsString = productIds.join(',');
      const url = `/locations?product_ids=${productIdsString}`;
      const response =
        await this.httpClient.get<ProductLocationsApiResponse>(url);

      // ✅ La API responde con { data: [...] }
      const list = Array.isArray(response.data?.data) ? response.data.data : [];
      return list;
    } catch (error: any) {
      throw error;
    }
  }
}
